export type LocaleCode = 'de' | 'en' | 'fr' | 'it'

export const locales = [
  {
    code: 'de' as const,
    iso: 'de-DE',
    file: 'de-DE.json',
    name: 'Deutsch',
    isCatchallLocale: true,
  },
  {
    code: 'en' as const,
    iso: 'en-GB',
    file: 'en-GB.json',
    name: 'English',
  },
  {
    code: 'fr' as const,
    iso: 'fr-FR',
    file: 'fr-FR.json',
    name: 'Français',
  },
  {
    code: 'it' as const,
    iso: 'it-IT',
    file: 'it-IT.json',
    name: 'Italiano',
  },
]

export const defaultLocale: LocaleCode = 'de'
